import { concatAll, switchMap } from 'rxjs/operators'

import { Epic } from 'modules/store'

import * as formActions from './form.actions'

import { i18nKeys } from '../../app.i18n'
import { AppProviders } from '../../app.module'
import { createErrorToast } from '../../shared'
import { sharedActions } from '../../shared/store'

const NAMESPACE = 'html'

const api = {
  stripHtml: () => `${NAMESPACE}/correct`,
}

export const stripHtmlEpic: Epic<any, any, AppProviders> = (actions$, _, { httpClient }) => {
  return actions$.ofType<formActions.StripHtmlFormAction>(sharedActions.STRIP_HTML_FORM).pipe(
    switchMap((action) => {
      const { html, complete } = action.payload

      return httpClient
        .post(api.stripHtml(), { html })
        .then((response) => {
          complete(response.data.html)
          const toastr = { message: i18nKeys.admin.htmlEditor.stripSuccessful }

          return [new sharedActions.AddToastAction(toastr)]
        })
        .catch((reason) => {
          const toastr = createErrorToast(reason)

          return [new sharedActions.AddToastAction(toastr)]
        })
    }),
    concatAll()
  )
}

export default stripHtmlEpic



// WEBPACK FOOTER //
// ./src/app/shared/store/form.epic.ts